<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
    <!-- Contenet page started-->
    <div class="common-page-contentwrap">
      <div class="col-md-12">
        <!-- breadcrumb -->
        <div class="page-breadcrumb">
          <ul class="page-breadcrumb__trail">
              <li><a>BluEye</a></li>
            </ul>
          <div class="page-breadcrumb__icons">
          <a routerLink="/home/marketconnect">
            <img src="../../../../assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>
        </div>
        </div>
        <!-- breadcrumb End -->
      </div>
    </div>
    <div class="row">
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-12 col-lg-6">
            <input type="button" class="readingsdays" value="Today"
                   (click)="statsDays('today');"
                   [ngClass]="noOfDays=='today'?'selected-btn':'unselected-btn'">
            <input type="button" class="readingsdays" value="Week"
                   (click)="statsDays('oneweek');"
                   [ngClass]="noOfDays=='oneweek'?'selected-btn':'unselected-btn'">
            <input type="button" class="readingsdays" value="Month"
                   (click)="statsDays('onemonth');"
                   [ngClass]="noOfDays=='onemonth'?'selected-btn':'unselected-btn'">
            <input type="button" class="readingsdays" value="Year"
                   (click)="statsDays('oneyear');"
                   [ngClass]="noOfDays=='oneyear'?'selected-btn':'unselected-btn'">
            <input type="button" class="readingsdays" value="Custom" (click)="statsDays('Custom');" *ngIf="customFromDate == '' && customToDate == ''"
                   [ngClass]="noOfDays == 'Custom' || (customFromDate != '' && customToDate != '') ? 'selected-btn' : 'unselected-btn'">
            <span (click)="statsDays('Custom');" *ngIf="customFromDate != '' && customToDate != ''" [ngClass]="noOfDays === 'Custom' || (customFromDate !== '' && customToDate !== '') ? 'selected-btn' : 'unselected-btn'">{{ customFromDate}} - {{ customToDate }}</span>
            <app-date-range-popup
              *ngIf="isDateRangePopupOpen"
              [fromDate]="customFromDate"
              [toDate]="customToDate"
              (close)="closeDateRangePopup()"
              (apply)="onDateRangeApply($event)">
            </app-date-range-popup>
          </div>
        </div>
      </div>
    </div>
    <div class="row cards-block">
      <div class="col-lg-12">
        <!--market connect card-->
        <div class="col-lg-6 market-connect-block">
          <h4 class="marketconnect">BluEye</h4>
          <div class="marketCard">
            <div class="row card-block">
                <div class="col-lg-6">
                  <span class="card-value">{{businessOnboarded}}</span>
                  <span class="card-label">Onboarded</span>
                </div>
                <div class="col-lg-6">
                    <span class="card-value">{{devices}}</span>
                    <span class="card-label">Devices</span>
                </div>
            </div>
            <div class="row card-block">
                <div class="col-lg-6">
                  <span class="card-value">{{snapsCount}}</span>
                  <span class="card-label">Snaps</span>
                </div>
                <div class="col-lg-6">
                    <span class="card-value">{{formattedTotalValue}}</span>
                    <span class="card-label">Value</span>
                </div>
            </div>
            <div>
              <p class="details marketconnectdetails">
                <span class="detailsicon">
                    <img title="Details" (click)="getBluEyeSubscribers()"
                    src="../../../../assets/img/marcketconnectreports/Report.svg"/>
                </span>
              </p>
            </div>
          </div>
        </div>
        <!--market connect card edn -->
        <div class="col-lg-3 hatchery-block"></div>
        <div class="col-lg-3 hatchery-block"></div>
      </div>
    </div>
    <!--Details table for hatchery, market connect and farms-->
    <div id="parent_element">
      <!--hatchery table data-->
      <div id="hatcheryreport">
        <div *ngIf="dataLoader">
          <div class="adjust">
            <div class="reports-loader"></div>
          </div>
        </div>
        <div class="row card-container" id="bluEyeCardConatiner" *ngIf="showBluEyeSubscriberDetails && !dataLoader"
             style="margin-top: 2%;margin-bottom: 2%">
          <div class="row list">
            <div class="col-xs-4">
              <p class="tableheading">BluEye Susbcribers - Report</p>
            </div>
            <div class="col-xs-4">

            </div>
            <div class="col-xs-4" style="padding: 0">
              <nav class="navbar tableactions">
                <div class="container-fluid actionpoints">
                  <ul class="nav navbar-nav navbar-right">
                    <li title="Export" (click)="exportExcel()"><a><span><img
                      src="../../../../assets/img/marcketconnectreports/export.svg"></span>Export</a></li>
                    <!-- <li title="Share" (click)="mail_content()"><a><span><img
                      src="../../../../assets/img/marcketconnectreports/share.svg"></span>Share</a>
                    </li> -->
                    <li class="zoomin" (click)="openFullScreen()"><a><img title="Zoom in"
                                                                                                 src="../../../../assets/img/marcketconnectreports/Zoomin.svg"
                                                                                                 width="18"></a></li>
                    <li class="zoomout" (click)="closeFullScreen()"><a><img title="Zoom out"
                                                                            src="../../../../assets/img/marcketconnectreports/zoomout.svg"
                                                                            width="18"></a></li>
                    <li class="closebtn" (click)="closeTable()"><a><img title="Close"
                                                                                           src="../../../../assets/img/marcketconnectreports/close.svg"
                                                                                           width="18"></a></li>
                  </ul>
                </div>
              </nav>
            </div>
          </div>
          <div class="row list">
            <div class="col-xs-12" style="border-bottom: 1px solid #ccc;">
              <div class="col-xs-4">
                <div class="row">
                  <ul class="nav nav-tabs batch batchtransactiontabs">
                    <li class="active"><a data-toggle="tab" href="#Hatcheries">BluEye</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-xs-3">
                <div class="search">
                  <img src="../../../../../../assets/img/png-icons-blubay/search_icon.svg" width="20" height="20" class="search_icon">
                  <input type="text" class="search_input" (keyup)="onFiltersApplied()" [(ngModel)]="bluEyeSearch" name="search" autocomplete="off" placeholder="Search by business etc">
                  <img src="../../../../../../assets/img/png-icons-blubay/search_close_icon.svg" width="20" height="20" class="search_close" *ngIf="bluEyeSearch != ''" (click)="this.bluEyeSearch = '';this.clearBluEyeSearchInput = false;onFiltersApplied()">
                </div>
              </div>
              <div class="col-xs-5">
                <P class="daysselection">
                  <input type="button" class="readingsdays" value="Today"
                         (click)="tableDays('today');"
                         [ngClass]="tablenoOfDays=='today'?'selected-btn':'unselected-btn'">
                  <input type="button" class="readingsdays" value="Week"
                         (click)="tableDays('oneweek');"
                         [ngClass]="tablenoOfDays=='oneweek'?'selected-btn':'unselected-btn'">
                  <input type="button" class="readingsdays" value="Month"
                         (click)="tableDays('onemonth');"
                         [ngClass]="tablenoOfDays=='onemonth'?'selected-btn':'unselected-btn'">
                  <input type="button" class="readingsdays" value="Year"
                         (click)="tableDays('oneyear');"
                         [ngClass]="tablenoOfDays=='oneyear'?'selected-btn':'unselected-btn'">
                  <input type="button" class="readingsdays" value="Custom" (click)="tableDays('Custom');" *ngIf="customBluEyeFromDate == '' && customBluEyeToDate == ''"
                         [ngClass]="tablenoOfDays=='Custom'?'selected-btn':'unselected-btn'">
                  <span (click)="tableDays('Custom');" *ngIf="customBluEyeFromDate != '' && customBluEyeToDate != ''" [ngClass]="tablenoOfDays === 'Custom' || (customBluEyeFromDate !== '' && customBluEyeToDate !== '') ? 'selected-btn' : 'unselected-btn'">{{ customBluEyeFromDate}} - {{ customBluEyeToDate }}</span>
                </P>
                <app-date-range-popup
                  *ngIf="isBluEyeDateRangePopupOpen"
                  [fromDate]="customBluEyeFromDate"
                  [toDate]="customBluEyeToDate"
                  (close)="closeBluEyeDateRangePopup()"
                  (apply)="onBluEyeDateRangeApply($event)">
                </app-date-range-popup>
              </div>
            </div>
          </div>
          <div class="actions-container">
            <diV class="filters_div">
              <!-- <span class="filter_label">Filter by</span> -->
              <div class="form-field custom-select">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Status</mat-label>
                  <mat-select
                    [(ngModel)]="status"
                    name="status"
                    (selectionChange)="statusFilter = true; onFiltersApplied()"
                  >
                    <mat-option [value]="undefined" disabled>Select status</mat-option>
                    <mat-option [value]="'false'">Active</mat-option>
                    <mat-option [value]="'true'">In Active</mat-option>
                  </mat-select>

                  <!-- Clear filter button -->
                  <button
                    mat-icon-button
                    (click)="statusFilter = false; status = undefined; onFiltersApplied();$event.stopPropagation()"
                    title="Clear Filters"
                    class="searchClose filtersClose"
                    *ngIf="statusFilter"
                    style="position: absolute; top: 15px; right: 30px;"
                  >
                    &times;
                  </button>
                </mat-form-field>
              </div>
            </diV>
          </div>
          <div class="row table-responsive" style="padding: 12px 14px;">
            <table class="table blueye-subscribers-table" *ngIf="bluEyeSubscribersList?.length > 0" id="cartcontent">
              <thead>
                <tr>
                  <th style="width: 50px;">S.No</th>
                  <th>Business Name</th>
                  <th>Device No</th>
                  <th>Device Status</th>
                  <th>Days Left</th>
                  <th>User Licenses</th>
                  <th style="width: 100px;">Status</th>
                </tr>
              </thead>
              <tbody *ngFor="let list of bluEyeSubscribersList; let i = index" class="business-group">
                <tr *ngFor="let device of list.devicesDetails; let devIdx = index" [ngClass]="{'border-top-group': devIdx === 0}">
                  <td *ngIf="devIdx === 0" [attr.rowspan]="list.devicesDetails?.length || 1" style="vertical-align: top; padding-top: 14px;">{{i+1}}</td>
                  <!-- Business Name -->
                  <td *ngIf="devIdx === 0" [attr.rowspan]="list.devicesDetails?.length || 1" style="vertical-align: top; padding-top: 14px;">
                    <span>{{ list.businessName || '--' }}</span>
                  </td>
                  <!-- Device Number -->
                  <td style="vertical-align: top; padding-top: 14px;">
                    <span>{{ device.deviceNumber || '--' }}</span>
                  </td>
                  <!-- Device Status -->
                  <td style="vertical-align: top; padding-top: 14px;">
                    <span [ngClass]="device.isActive ? 'active-status' : 'inactive-status'">{{ device.isActive ? 'Active' : 'Inactive' }}</span>
                  </td>
                  <!-- Days Left -->
                  <td style="vertical-align: top; padding-top: 14px;">
                    <span>{{ device?.bluEye?.durationLeft || '--' }}</span>
                  </td>
                  <!-- User Licenses -->
                  <td style="vertical-align: top; padding-top: 10px;">
                    <div class="license-item-row" *ngFor="let license of device?.bluEye?.userLicensesDetails">
                      <span class="lic-role">{{ license.roleName || '--' }}</span>
                      <span class="lic-count">{{ license.noOfLicenses || '0' }}</span>
                    </div>
                    <span *ngIf="!device?.bluEye?.userLicensesDetails || device?.bluEye?.userLicensesDetails.length === 0">--</span>
                  </td>
                  <!-- Overall Status -->
                  <td *ngIf="devIdx === 0" [attr.rowspan]="list.devicesDetails?.length || 1" style="vertical-align: top; padding-top: 14px;">
                    <span [ngClass]="!list.isExpired ? 'active-status' : 'inactive-status'">{{ list.isExpired ? 'In Active' : 'Active'}}</span>
                  </td>
                </tr>

                <!-- Fallback when 0 devices -->
                <tr class="border-top-group" *ngIf="!list.devicesDetails || list.devicesDetails.length === 0">
                  <td style="vertical-align: top; padding-top: 14px;">{{i+1}}</td>
                  <td style="vertical-align: top; padding-top: 14px;">
                    <span>{{ list.businessName || '--' }}</span>
                  </td>
                  <td colspan="4" style="vertical-align: middle; text-align: center; color: #888;">No devices subscribed</td>
                  <td style="vertical-align: top; padding-top: 14px;">
                    <span [ngClass]="!list.isExpired ? 'active-status' : 'inactive-status'">{{ list.isExpired ? 'In Active' : 'Active'}}</span>
                  </td>
                </tr>
              </tbody>
            </table>
            <div *ngIf="listLoader" class="loader-div">
              <div class="adjust">
                <div class="loader2 list-loader"></div>
              </div>
            </div> 
            <div *ngIf="bluEyeSubscribersList?.length == 0" class="noDataFoundMessage">No Data Available</div>
          </div>
        </div>
      </div>
    </div>
  </div>